import {
    Component,
    Input
}                                from '@angular/core';

import {
    MobileCell,
    MobileCellLevelComponent
}                                from '../mobile-cell/';

import { MobileCellNrnsaCommon } from './'


@Component({
    selector:    'qp-mobile-cell-nrnsa-level',
    templateUrl: 'mobile-cell-nrnsa-level.component.html',
    styleUrls:   [
        'mobile-cell-nrnsa-level.component.css'
    ],
    imports:     [
    ]
})
export class MobileCellNrnsaLevelComponent extends MobileCellLevelComponent
{
    //
    // Getters
    //

    public static override getLevelToolTip(d: MobileCell): string
    {
        return super.getLevelToolTip(d)
            + (d instanceof MobileCellNrnsaCommon
                ? (d.rsrp ? "\nRsrp: " + d.rsrp : "")
                    + (d.rsrq  ? "\nRsrq: "  + d.rsrq   : "")
                    + (d.rssnr ? "\nRssnr: " + d.rssnr  : "")
                
                : ""
            );
    }
}